import { BoxV2 as Box, Flex } from 'portal-commons';
import { FunctionComponent, ReactNode } from 'react';

const PageTitle: FunctionComponent<{ note?: ReactNode }> = ({
  note,
  children,
}) => {
  return (
    <Flex
      sx={{
        fontWeight: 800,
        fontSize: '27px',
        lineHeight: '32px',
        color: '#333e41',
        gap: 'xs',
      }}
    >
      {children}
      {note && (
        <Box
          as="span"
          sx={{
            alignSelf: 'flex-end',
            marginBottom: '4px',
            fontWeight: 400,
            fontSize: '12px',
            lineHeight: '14px',
            color: '#666E71',
          }}
        >
          {note}
        </Box>
      )}
    </Flex>
  );
};

export default PageTitle;
